import React from 'react';
import { Message } from 'semantic-ui-react';
import { getNotificationIcon } from '../helpers/utils';

const ErrorMessage = (props) => {
    const { type = 'error', header = undefined, errors = [], onDismiss = undefined, className = undefined } = props;
    let message = null;

    if (typeof errors === 'string') {
        message = { content: errors };
    } else if (errors.length === 1) {
        message = { content: errors[0] };
    } else if (errors.length > 1) {
        message = {
            header: 'There was some errors with your submission',
            list: errors
        };
    }

    if (message && header) {
        message.header = header;
    }

    return message && <Message visible error onDismiss={onDismiss} {...message} className={className} icon={getNotificationIcon(type)} />;
};

export default ErrorMessage;
